import Embed from '@editorjs/embed';
import Table from '@editorjs/table';
import EditorjsList from '@editorjs/list';
import Warning from '@editorjs/warning';
import Code from '@editorjs/code';
import LinkTool from '@editorjs/link';
import SimpleImage from '@editorjs/simple-image';
import Raw from '@editorjs/raw';
import Header from '@editorjs/header';
import Quote from '@editorjs/quote';
import Marker from '@editorjs/marker';
import CheckList from '@editorjs/checklist';
import Delimiter from '@editorjs/delimiter';
import InlineCode from '@editorjs/inline-code';

export const EDITOR_JS_TOOLS = {
	embed: Embed,
	table: Table,
	list: EditorjsList,
	warning: Warning,
	code: Code,
	linkTool: LinkTool,
	image: SimpleImage,
	raw: Raw,
	header: Header,
	quote: Quote,
	marker: Marker,
	checklist: CheckList,
	delimiter: Delimiter,
	inlineCode: InlineCode,
};
